import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";


export const UtilizationDashboardStyled = styled.div`
  .header {
    margin: 5px 36px;
  }
  .title {
    border-bottom: 1px solid #dedafb;
    min-height: 45px;
    display: flex;
    align-items: center;
  }
  .dateRange {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-top: 12px;
  }
  .prog-wrap {
    margin-bottom: 20px;
  }
  .accordian-padding {
    padding: 10px;
  }
  .deliverable {
    margin: 10px 0;
  }
  .barContainer {
    padding: 36px;
    display: grid;
    gap: 8px;
  }

  .toggl {
    width: 100%;
    display: flex;
    gap: 24px;
    align-items: center;
  }
  .barLabels {
    display: flex;
    margin: 0px 48px 0px 60px;
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
    align-self: stretch;
  }
  .totalProgressBar {
    padding: 8px 12px;
    border: 1px solid var(--flow-30-neutral-3, #EFEDFD);
    border-radius: 4px;

    .MuiPaper-root{
      box-shadow: none !important;
    }
  }
  .inactive {
  opacity: 0.5;
}


  .transparent-linear-bar {
    background: red;
  }
  .MuiAccordionSummary-root {
    flex-direction: row !important;
    gap: 24px !important;
    margin: 8px 0 !important;
  }
   /* Custom styles for rectangular switch */
   .MuiSwitch-root {
    width: 42px;
    height: 24px;
    padding: 0;
    display: flex;
  }
  .MuiSwitch-switchBase {
  padding: 2px;
  transform: translateX(18px); /* Default position on the right */
  &.Mui-checked {
    transform: translateX(2px); /* Move to the left when enabled */
    color: #fff;
    + .MuiSwitch-track {
      background-color: white; /* Primary color for enabled state */
      opacity: 1;
    }

    /* Ensure the thumb color changes when checked */
    .MuiSwitch-thumb {
      background-color: #080425 !important; 
    }
  }
}
.MuiSwitch-thumb {
  width: 20px;
  height: 20px;
  border-radius: 4px; /* Make thumb rectangular */
  background-color: ${COLOUR_CONSTANT.theme.lightPink}; /* Default thumb color */
  transition: background-color 0.3s;
}

.MuiSwitch-track {
  border-radius: 4px; /* Make track rectangular */
  background-color: white; /* Default track background color */
  border: 1px solid ${COLOUR_CONSTANT.theme.lightPink};
  opacity: 1;
  transition: background-color 0.5s;
}

`;
